import React from 'react';
import type { PropsWithChildren } from 'react';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import 'src/styling/global.scss';

import CareerContentProvider from 'src/content/career-content-provider';

import CareerPageLayoutContent from './career-page-layout-content';
import type { SnippetsProps } from './snippets';

type CareerPageLayoutProps = PropsWithChildren<{
  snippets?: Partial<SnippetsProps>;
  globalCmsPageData: unknown;
}>;

const CareerPageLayout = ({ globalCmsPageData, ...props }: CareerPageLayoutProps) => {
  return (
    <CareerContentProvider globalAndCareerCmsPageData={globalCmsPageData}>
      <CareerPageLayoutContent {...props} />
    </CareerContentProvider>
  );
};

export default CareerPageLayout;
